import numberToDisplayString from 'Utils/numberToDisplayString';

export default function (windSpeed?: number | null): string {
	if (typeof windSpeed !== 'undefined') {
		return numberToDisplayString(windSpeed || 0) + ' m/s';
	} else {
		return 'N/A';
	}
}
